<kuv-loading></kuv-loading>
<kuv-alert></kuv-alert>
<div class="container-fluid p-5">
  <h3>Gestión de Gastos</h3>
  <div class="btn btn-primary my-2" (click)="agregar()"><i class="fas fa-plus-circle me-2"></i>Registrar Nuevo Gasto
  </div>
  <kuv-lazy-table [url]="config.apiUrl + 'gasto/index'" [urlExcel]="config.apiUrl + 'gasto/excel'"
    [headersBlob]="sesion.headersBlob" [columnas]="columnas" [acciones]="acciones" [reloadEmitter]="reloadEmitter"
    [hasShadow]="true" [headers]="sesion.headers" [isRounded]="true" [filtros]="filtros">
  </kuv-lazy-table>
</div>